import { types } from 'mobx-state-tree';
import { v4 as uuid } from 'uuid';

import DisplayedCard from './DisplayedCard';

/**
 * Modal for top cards on the results page for the purpose of email marketing events
 */
const CreditCardTopCard = types
    .model({
        // Required for relation database card table to not overwrite previous top cards
        id: types.optional(types.identifier, uuid),
        // TODO: Remove integer once legacy Id migrated https://ratehub.atlassian.net/browse/CCDEP-2853
        cardId: types.maybe(types.union(types.string, types.integer)),
    });

const TopCard = types.compose('TopCard', DisplayedCard, CreditCardTopCard);

export default TopCard;
